import React from "react";
import { connect } from 'react-redux';
import { Actions as DEPUTY_ACTIONS } from './deputy/store/deputyActions';
import DeputyImport from './deputy/DeputyImport';
import TimesheetImport from "../timesheets/TimesheetImport";
import WorkforceImport from "./workforce/WorkforceImport";

import apiURL from'../../store/actions/apiURL';

const IntegrationTimesheetImport = ({
    deputyConnected,
    deputyNeedsReconnection,
    integrations,
    userPermissions
}) => {

    if (userPermissions == 'Read') return null

    if (deputyNeedsReconnection) return (
        <a
            className="btn btn-deputy"
            href={`https://once.deputy.com/my/oauth/login?client_id=3e1bae19831c0d9bf81b8c9b674f2f72b2683311&redirect_uri=${apiURL}/deputy/auth&response_type=code&scope=longlife_refresh_token`}
        >
            Reconnect Deputy
        </a>
    )
    if (deputyConnected) return (
        <DeputyImport />
    )

    if (integrations?.includes('Tanda')) return <WorkforceImport isFor={'Timesheets'} />
    if (integrations?.includes('Deputy')) return <DeputyImport />


    return <TimesheetImport />
}


const mapStateToProps = (state) => {
    const timeAttendanceList = Object.values(state.integration?.timeAttendance || {})?.reduce((prev, curr) => {
        prev.push(curr.name)
        return prev
    }, [])
    return {
        deputyConnected: state.deputy.connected,
        deputyNeedsReconnection: state.deputy.needsReconnection,
        company: state?.company?.settings?.org,
        integrations: timeAttendanceList,
        userPermissions: state?.permissions?.my?.permissions?.timesheets,
    }
}

const mapDispatchToProps = dispatch => ({
    isConnectedWithDeputy: () => dispatch(DEPUTY_ACTIONS.isConnectedWithDeputy()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IntegrationTimesheetImport)

